import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pos-payment-cash',
  templateUrl: './pos-payment-cash.component.html',
  styleUrls: ['./pos-payment-cash.component.scss']
})
export class PosPaymentCashComponent implements OnInit, OnDestroy {
  @Input() totalOrderOutstanding: number;
  @Input() amountOutstanding: number;
  @Input() storeId: number;
  @Input() containerId: number;
  @Input() containerDesc: string
  @Input() equipmentTypeCode: string;
  @Input() paymentType: string;

  @Output() formChanged: EventEmitter<any> = new EventEmitter<any>(null);

  formSubscription: Subscription;
  form: FormGroup;

  constructor(
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      amountPaid: [null],
      amountTendered: [null],
      amountOutstanding: [null],
      amountDifference: [null]
    });
  }

  ngOnInit() {
    if (this.paymentType && this.paymentType === 'REFUND') {
      this.form.controls['amountPaid'].setValidators(Validators.compose([Validators.required, Validators.max(-1)]));
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.max(-1)]));
    } else {
      this.form.controls['amountPaid'].setValidators(Validators.compose([Validators.required, Validators.min(0.01)]));
      this.form.controls['amountTendered'].setValidators(Validators.compose([Validators.required, Validators.min(0.01)]));
    }

    this.form.controls['amountOutstanding'].disable();
    this.form.controls['amountDifference'].disable();
    this.form.controls['amountTendered'].disable();

    this.amountPaidChanged();
    // this.amountPaidFocusOut();

    this.formChanged.emit({
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      formValue: this.form.getRawValue(),
      formValid: this.form.valid,
    });

    this.formSubscription = this.form.valueChanges.subscribe(s => {
      this.formChanged.emit({
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        formValue: this.form.getRawValue(),
        formValid: this.form.valid,
      });
    });
  }

  ngOnDestroy(): void {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  amountPaidChanged() {
    if (this.paymentType && (this.paymentType === 'REFUND' || this.paymentType === 'DEPOSIT-REFUND')) {
      const amountPaid = +this.form.value.amountPaid || 0;
      const amountToPay = +this.totalOrderOutstanding || 0;
      const minusOutstanding = amountPaid - amountToPay;

      this.form.controls['amountOutstanding'].setValue(+amountToPay.toFixed(2));
      this.form.controls['amountDifference'].setValue(+(amountToPay - amountPaid).toFixed(2));
      this.form.controls['amountTendered'].setValue(+amountPaid.toFixed(2));

    } else if (this.paymentType && (this.paymentType === 'ACCOUNT' || this.paymentType === 'RCS-ACCOUNT')) {
      const amountPaid = +this.form.value.amountPaid || 0;
      const amountToPay = +this.totalOrderOutstanding || 0;
      const minusOutstanding = amountPaid - amountToPay;

      this.form.controls['amountOutstanding'].setValue(0);
      this.form.controls['amountDifference'].setValue(0);
      this.form.controls['amountTendered'].setValue(+amountPaid.toFixed(2));
    } else if (this.paymentType && (this.paymentType === 'TFG-ACCOUNT')) {
      const amountPaid = +this.form.value.amountPaid || 0;
      const amountToPay = +this.totalOrderOutstanding || 0;
      const minusOutstanding = amountPaid - amountToPay;

      this.form.controls['amountOutstanding'].setValue(0);
      this.form.controls['amountDifference'].setValue(0);
      this.form.controls['amountTendered'].setValue(+amountPaid.toFixed(2));
    }
    else {
      const amountPaid = +this.form.value.amountPaid || 0;
      const amountToPay = +this.totalOrderOutstanding || 0;
      const minusOutstanding = amountPaid - amountToPay;

      this.form.controls['amountOutstanding'].setValue(+amountToPay.toFixed(2));
      this.form.controls['amountDifference'].setValue(+minusOutstanding.toFixed(2));

      if (minusOutstanding >= 0) {
        this.form.controls['amountTendered'].setValue(+(amountPaid - minusOutstanding).toFixed(2));
      } else {
        this.form.controls['amountTendered'].setValue(+amountPaid.toFixed(2));
      }
    }

  }

  amountPaidFocusOut() {
    if (!this.form.value.amountTendered) return;

    const amountPaid = +this.form.value.amountPaid || 0;
    this.form.controls['amountPaid'].setValue(+amountPaid.toFixed(2));
  }

}
